import { Component, OnInit } from '@angular/core';
import { MemberService } from '../../../services/member.service';
import { Member } from '../../../models/member';
import { Category } from 'src/app/models/category';
import { Subscription } from 'rxjs';
import { CategoryService } from 'src/app/services/category.service';
import { CieloCode } from 'src/app/models/ceilo-code';

@Component({
  selector: 'app-member-file-dialog',
  templateUrl: './member-file-dialog.component.html',
  styleUrls: ['./member-file-dialog.component.scss']
})
export class MemberFileDialogComponent implements OnInit {

  public members: any[] = [];
  public errors: any[] = [];
  private fileReaded: any;
  public spinner: boolean = false;

  public categories: Category[] = [];
  public subscriptionCategory: Subscription;

  public allMembers: Member[] = [];
  public subscriptionAllMembers: Subscription;

  public situations: any[] = [];
  public cieloCodes: CieloCode[] = [];

  constructor(
    private _memberService: MemberService,
    private _categoryService: CategoryService,
    //   private _regionalService: RegionalService
  ) { }

  ngOnInit() {
    this.loadCategories();
    this.loadAllMembers();
  }

  ngOnDestroy() {
    if (this.subscriptionCategory)
      this.subscriptionCategory.unsubscribe();
  }

  readCSVFile(fileInput: any) {
    //read file from input
    this.errors = [];

    this.fileReaded = fileInput.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);

    reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[0].split(';');
      let lines = [];

      for (var i = 1; i < allTextLines.length; i++) {
        //console.log(allTextLines[i])
        let data = allTextLines[i].split(';');

        if (data[0] != "") {

          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          lines.push(tarr);
        }
      }

      for (let i = 0; i < lines.length; i++) {
        let entity: any = {}

        //  entity.id = item.payload.doc.id;
        entity.category = this.removeVazio(lines[i][1]);
        entity.situation = this.removeVazio(lines[i][2]);
        entity.name = this.removeVazio(lines[i][3]).trim();

        entity.address = this.removeVazio(lines[i][4]);
        entity.number = this.removeVazio(lines[i][5]);
        entity.complement = this.removeVazio(lines[i][6]);
        entity.district = this.removeVazio(lines[i][7]);
        entity.postalCode = this.removeVazio(lines[i][8]);
        entity.city = this.removeVazio(lines[i][9]);
        entity.state = this.removeVazio(lines[i][10]);
        entity.country = this.removeVazio(lines[i][11]);

        entity.email = this.removeVazio(lines[i][12]);
        entity.email2 = this.removeVazio(lines[i][13]);

        entity.cellPhone = this.removeVazio(lines[i][14]);
        entity.faxPhone = this.removeVazio(lines[i][15]);
        entity.clinicPhone = this.removeVazio(lines[i][16]);
        entity.hospitalPhone = this.removeVazio(lines[i][17]);
        entity.aux1Phone = this.removeVazio(lines[i][18]);
        entity.aux2Phone = this.removeVazio(lines[i][19]);

        entity.rg = this.removeVazio(lines[i][20]);
        entity.cpf = this.removeVazio(lines[i][21]);
        entity.crm = this.removeVazio(lines[i][22]);

        entity.dateBirth = this.removeVazio(lines[i][23]);
        entity.dateFiliation = this.removeVazio(lines[i][24]);
        entity.dateTitle = this.removeVazio(lines[i][25]);

        entity.regional = this.removeVazio(lines[i][26]);
        entity.sex = this.removeVazio(lines[i][27]); //27

        entity.balance = 0;
        entity.obs = "";

        if (this.validateMember(entity, i + 2)) {
          this.members.push(entity)
        }

      }


    }
  }

  validateMember(member, position) {

    let valid: boolean = true;

    if (member.name.length == 0) {
      this.errors.push(position + " - faltou o nome")
      valid = false;
    } else {
      member.name = this.firstUpper(member.name)
    }

    //  if (!member.email || member.email.length == 0) {
    //    this.errors.push(position + " - " + member.name + " - faltou o email")
    //    valid = false;
    //  }

    ////////////////////////////////////////////
    // member.category = 'sRpmcwTBmJZYUhyZ5XsB'


    if (!member.category || member.category.length == 0) {
      this.errors.push(position + " - " + member.name + " - faltou a categoria")
      valid = false;
    } else {
      let cat = this.categories.find(function (e) {
        return e.name.toUpperCase() == member.category.toUpperCase()
      })

      if (cat) {
        //  console.log("cat.name: " + cat.name)
      }
      else {
        console.log("não achou - member.category: " + member.category)
      }


      member.category = cat.id
    }


    //  if (!member.regional || member.regional.length == 0) {
    //    this.errors.push(position + " - " + member.name + " - faltou a regional")
    //     valid = false;
    //   }


    if (!member.situation || member.situation.length == 0) {
      this.errors.push(position + " - " + member.name + " - faltou a situação")
      valid = false;
    } else {
      if (member.situation == "Quite")
        member.situation = "0"
      else if (member.situation == "Não-Quite")
        member.situation = "1"
      else
        member.situation = "2"
    }

    if (!member.cellPhone || member.cellPhone.length == 0) {
      this.errors.push(position + " - " + member.name + " - faltou o celular")
      valid = false;
    } else {
      member.cellPhone = this.formatPhone(member.cellPhone);
    }

    if (member.faxPhone || member.faxPhone.length != 0) {
      member.faxPhone = this.formatPhone(member.faxPhone);
    }

    if (member.clinicPhone || member.clinicPhone.length != 0) {
      member.clinicPhone = this.formatPhone(member.clinicPhone);
    }

    if (member.hospitalPhone || member.hospitalPhone.length != 0) {
      member.hospitalPhone = this.formatPhone(member.hospitalPhone);
    }

    if (member.aux1Phone || member.aux1Phone.length != 0) {
      member.aux1Phone = this.formatPhone(member.aux1Phone);
    }

    if (member.aux2Phone || member.aux2Phone.length != 0) {
      member.aux2Phone = this.formatPhone(member.aux2Phone);
    }

    if (member.postalCode || member.postalCode.length != 0) {
      member.postalCode = this.formatCEP(member.postalCode);
    }

    if (!member.cpf || member.cpf.length == 0) {
      this.errors.push(position + " - " + member.name + " - faltou o cpf")
      valid = false;
    } else if (this.memberExist(member)) {
      this.errors.push(position + " - " + member.name + " - CPF " + member.cpf + " está em uso.")
      valid = false;
    } else {
      member.cpf = this.formatCPF(member.cpf)
    }

    if (!member.dateBirth || member.dateBirth.length == 0) {
      // this.errors.push(position + " - " + member.name + " - faltou o email")
      // valid = false;
    } else {
      let parts = member.dateBirth.split("/")
      member.dateBirth = new Date(parts[2] as number, parts[1] as number, parts[0] as number)
    }

    if (!member.dateFiliation || member.dateFiliation.length == 0) {
      // this.errors.push(position + " - " + member.name + " - faltou o email")
      // valid = false;
    } else {
      let parts = member.dateFiliation.split("/")
      member.dateFiliation = new Date(parts[2] as number, parts[1] as number, parts[0] as number)
    }

    if (!member.dateTitle || member.dateTitle.length == 0) {
      // this.errors.push(position + " - " + member.name + " - faltou o email")
      // valid = false;
    } else {
      let parts = member.dateTitle.split("/")
      member.dateTitle = new Date(parts[2] as number, parts[1] as number, parts[0] as number)
    }

    member.balance = 0;


    return valid;
  }

  formatPhone(phone) {
    phone = phone.replace("(", "");
    phone = phone.replace(")", "");
    phone = phone.replace("-", "");
    phone = phone.replace(" ", "");

    if (phone.length < 11) {
      let pre = phone.substr(0, 2)
      let num = phone.substr(2, 9)

      let first = num.substr(0, 1)

      if (first == "9") {
        num = "9" + num
      } else if (first == "8") {
        num = "9" + num
      } else if (first == "7") {
        num = "9" + num
      } else {
        num = "0" + num
      }

      phone = pre + num

    }

    return phone;
  }

  formatCEP(cep) {
    cep = cep.replace("-", "");
    return cep;
  }

  formatValue(value) {
    value = value.replace("R$ ", "");
    value = value.replace(".", "");
    value = value.replace(".", "");
    value = value.replace(".", "");
    value = value.replace(",", ".");
    return value as number;
  }

  removeVazio(field) {
    if (field) {
      if (field.toUpperCase() == "VAZIO" || field.toUpperCase() == "NÃO POSSUI") {
        field = ""
      }
      if (field == "*")
        field = ""
    }
    return field
  }

  firstUpper(text) {

    var textRet = ""

    if (text) {

      // separa entre espaços 
      let parts = text.split(" ")
      // formata a primeira letra de cada parte maiúscula        
      parts.forEach(function (part) {

        if (part.toUpperCase() == "DA" || part.toUpperCase() == "DE" || part.toUpperCase() == "DI" || part.toUpperCase() == "DO" || part.toUpperCase() == "DU" || part.toUpperCase() == "AS" || part.toUpperCase() == "E" || part.toUpperCase() == "A" || part.toUpperCase() == "DAS" || part.toUpperCase() == "DOS" || part.toUpperCase() == "ÀS") {
          textRet += part.toLowerCase() + " "
        }
        else {
          var firstLetter = part.substring(0, 1)
          var otherLetters = part.substring(1, part.length)
          textRet += firstLetter.toUpperCase() + otherLetters.toLowerCase() + " "
        }
      })
    }
    return textRet
  }

  formatCPF(cpf) {
    cpf = cpf.replace(".", "");
    cpf = cpf.replace(".", "");
    cpf = cpf.replace("-", "");
    return cpf
  }

  loadCategories(): any {

    this.subscriptionCategory = this._categoryService.select()
      .subscribe((result) => {

        this.categories = result.map(item => {
          let entity = new Category();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          return entity;
        });

      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  /*
    loadRegionals(): any {
  
      this.subscriptionRegionals = this._regionalService.select()
        .subscribe((result) => {
  
          this.regionals = result.map(item => {
            let entity = new Regional();
            entity.id = item.payload.doc.id;
            entity.name = item.payload.doc.data().name;
            entity.short = item.payload.doc.data().short;
            return entity;
          });
  
        },
          (error) => {
            console.log(JSON.stringify(error))
          })
  
    }
  */
  
  loadAllMembers(): any {

    this.subscriptionAllMembers = this._memberService.select()
      .subscribe((result) => {

        this.allMembers = result.map(item => {
          let entity = new Member();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.cpf = item.payload.doc.data().cpf;
          return entity;
        });

      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  memberExist(member: any) {

    member.cpf = member.cpf.trim()
    let cpf = member.cpf.replace(".", "").replace(".", "").replace("-", "");

    let exist = this.allMembers.find((e) => {

      if (e.cpf)
        e.cpf = e.cpf.trim()

      return e.cpf == cpf
    })

    if (exist) {
      return true
    } else {
      return false
    }

  }

  readCSVSituacao(fileInput: any) {
    //read file from input
    this.errors = [];

    this.fileReaded = fileInput.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);

    reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[0].split(';');
      let lines = [];

      for (var i = 1; i < allTextLines.length; i++) {
        //console.log(allTextLines[i])
        let data = allTextLines[i].split(';');

        if (data[0] != "") {

          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          lines.push(tarr);
        }
      }

      for (let i = 0; i < lines.length; i++) {
        let entity: any = {
          cpf: this.removeVazio(this.formatCPF(lines[i][1])),
          name: this.removeVazio(lines[i][2]),
          situation: this.removeVazio(lines[i][3]),
          category: this.removeVazio(lines[i][4]),
          balance: this.formatValue(lines[i][5]),
          obs: this.removeVazio(lines[i][6]) + " (" + this.removeVazio(lines[i][7]) + ")"
        }

        if (this.validateSituation(entity, i + 2)) {
          console.log(JSON.stringify(entity))
          console.log("--------------------------------------")
          this.situations.push(entity)
        }

      }

    }
  }

  validateSituation(situation, position) {

    let valid: boolean = true;

    situation.category = situation.category.replace("Membro ", "")

    let cat = this.categories.find(function (e) {
      return e.name == situation.category
    })

    if (cat) {
      situation.category = cat.id
    } else {
      this.errors.push(position + " - erro categoria")
      valid = false;
    }

    if (situation.name.length == 0) {
      this.errors.push(position + " - faltou o nome")
      valid = false;
    }

    if (!situation.cpf || situation.cpf.length == 0) {
      this.errors.push(position + " - " + situation.name + " - faltou o CPF")
      valid = false;
    }

    if (!situation.situation || situation.situation.length == 0) {
      this.errors.push(position + " - " + situation.name + " - faltou a situação")
      valid = false;
    } else {
      if (situation.situation == "1") {
        if (!situation.balance || situation.balance.length == 0) {
          this.errors.push(position + " - " + situation.name + " - faltou o débito")
          valid = false;
        }
      }
    }

    if (situation.obs == " ()")
      situation.obs = ""


    return valid;
  }

  readCSVCieloCodes(fileInput: any) {

    this.errors = [];

    this.fileReaded = fileInput.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);

    reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[0].split(';');
      let lines = [];

      //get all lines
      for (var i = 1; i < allTextLines.length; i++) {
        let data = allTextLines[i].split(';');
        if (data[0] != "") {
          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }
          lines.push(tarr);
        }
      }

      // read all lines
      for (let i = 0; i < lines.length; i++) {

        let code: any = new CieloCode();

        code.code = lines[i][0]
        code.message = lines[i][1]

        this.cieloCodes.push(code)

      }

    }
  }

  uploadCSVFile() {

    if (this.members.length > 0) {
      this._memberService.updateCSVMembers(this.members);
    }

    if (this.situations.length > 0) {
      console.log("this.situations.length: " + this.situations.length)
      this._memberService.updateCSVSituations(this.situations);
    }

  }

  updateCSVCieloCodes() {

    if (this.cieloCodes.length > 0) {
      this._memberService.updateCSVCieloCodes(this.cieloCodes);
    }

  }



  
}